/**
 * @generated SignedSource<<47af0dd2f3cb78a1ac2360aa99ebc423>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SkillResourceGetSupportSkillsSkillStatesQuery$variables = {
  skillId: string;
  studentId: string;
  targetGroupId: string;
};
export type SkillResourceGetSupportSkillsSkillStatesQuery$data = {
  readonly supportSkillsSkillStates: ReadonlyArray<{
    readonly skillRelevance: {
      readonly id: string;
      readonly name: string | null | undefined;
    };
    readonly studentSkill: {
      readonly id: string;
      readonly readinessScore: any | null | undefined;
      readonly skill: {
        readonly code: string | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
        readonly summary: string | null | undefined;
      } | null | undefined;
      readonly skillAssessment: {
        readonly score: number;
      } | null | undefined;
      readonly skillSubstate: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    };
  }>;
};
export type SkillResourceGetSupportSkillsSkillStatesQuery = {
  response: SkillResourceGetSupportSkillsSkillStatesQuery$data;
  variables: SkillResourceGetSupportSkillsSkillStatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skillId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "studentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "targetGroupId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "skillId",
    "variableName": "skillId"
  },
  {
    "kind": "Literal",
    "name": "skillRelevanceIds",
    "value": [
      "SkillRelevanceNode:2",
      "SkillRelevanceNode:3"
    ]
  },
  {
    "kind": "Variable",
    "name": "studentId",
    "variableName": "studentId"
  },
  {
    "kind": "Variable",
    "name": "targetGroupId",
    "variableName": "targetGroupId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillRelevanceNode",
  "kind": "LinkedField",
  "name": "skillRelevance",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillSubstateNode",
  "kind": "LinkedField",
  "name": "skillSubstate",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readinessScore",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillNode",
  "kind": "LinkedField",
  "name": "skill",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SkillResourceGetSupportSkillsSkillStatesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SupportSkill",
        "kind": "LinkedField",
        "name": "supportSkillsSkillStates",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StudentSkillNode",
            "kind": "LinkedField",
            "name": "studentSkill",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StudentSkillAssessmentNode",
                "kind": "LinkedField",
                "name": "skillAssessment",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SkillResourceGetSupportSkillsSkillStatesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SupportSkill",
        "kind": "LinkedField",
        "name": "supportSkillsSkillStates",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StudentSkillNode",
            "kind": "LinkedField",
            "name": "studentSkill",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StudentSkillAssessmentNode",
                "kind": "LinkedField",
                "name": "skillAssessment",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8704ff8e6d8357dd96d833b115ba7606",
    "id": null,
    "metadata": {},
    "name": "SkillResourceGetSupportSkillsSkillStatesQuery",
    "operationKind": "query",
    "text": "query SkillResourceGetSupportSkillsSkillStatesQuery(\n  $skillId: ID!\n  $studentId: ID!\n  $targetGroupId: ID!\n) {\n  supportSkillsSkillStates(skillId: $skillId, studentId: $studentId, targetGroupId: $targetGroupId, skillRelevanceIds: [\"SkillRelevanceNode:2\", \"SkillRelevanceNode:3\"]) {\n    skillRelevance {\n      id\n      name\n    }\n    studentSkill {\n      id\n      skillAssessment {\n        score\n        id\n      }\n      skillSubstate {\n        id\n        name\n      }\n      readinessScore\n      skill {\n        id\n        code\n        name\n        summary\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bce6e9b2e9ae4b9ad4ae12c466af3b4f";

export default node;
